import { useMemo } from 'react';
import { calcBreakpointSize } from './ui/styles';
import { getElementDimension, isValidPercentageUnit, defaultImageCardDimensions } from '../utils';

// Hook to calculate the breakpoint based on the width of the element
export var useBreakpoint = function useBreakpoint() {
  var dimensionWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var divRef = arguments.length > 1 ? arguments[1] : undefined;
  var breakpoint = useMemo(function () {
    var widthToCalculate;
    if (dimensionWidth) {
      if (isValidPercentageUnit(dimensionWidth) && divRef.current) {
        var width = getElementDimension(divRef.current, 'width');
        widthToCalculate = width || defaultImageCardDimensions.width;
      } else {
        widthToCalculate = dimensionWidth;
      }
    } else {
      widthToCalculate = defaultImageCardDimensions.width;
    }
    return calcBreakpointSize(parseInt("".concat(widthToCalculate), 10));
  }, [dimensionWidth, divRef]);
  return breakpoint;
};